import { useNavigate } from 'react-router-dom';
import { getLabPadvishRequestList, getPadvishRequestList, padvishRequestFinancialApprove } from "../../api/api"
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks"
import { errorNotify, sucessNotify } from "../../services/toast.notification"
import { useEffect, useState } from 'react';
import { UpdatePadvishRequestList } from '../../redux/reducers/padvishRequestSlice';
import { Dropdown, Menu, Row, Space } from 'antd';
import CustomTable from '../../components/_common/Table';
import { ColumnsType } from 'antd/lib/table';
import { DownOutlined, DollarOutlined, BuildOutlined, DeliveredProcedureOutlined } from '@ant-design/icons';
import { AssignInstallerDialog } from './assignInstallerDialog';


const PadvishRequest = () => {
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [permission, setPermission] = useState(false);
    const [assignInstallerDialogPayload, setAssignInstallerDialogPayload] = useState({ requestid: 0 });
    const [showAssignInstallerDialog, setShowAssignInstallerDialog] = useState(false);

    const [expandedRowRender] = useState([
        { title: 'آزمایشگاه', val: 'str_LabPersianName' }
        , { title: 'تعداد کاربر', val: 'int_CountUserPadvish' }
        , { title: 'وضعیت', val: 'str_Status' }
        , { title: 'تاریخ درخواست', val: 'str_RequestDate' }
        , { title: 'تایید مالی', val: 'str_FinancialApproveDate' }
        , { title: 'نصاب', val: 'str_FullName' }
        , { title: 'تاریخ اتمام کار', val: 'str_FinilizeDate' }

    ]);
    const columns: ColumnsType<any> = [

        {
            title: 'عملیات',
            width: 70, dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Dropdown overlay={menu(record)}>
                    <a onClick={(e) => e.preventDefault()}>
                        <Space>
                            <DownOutlined />
                        </Space>
                    </a>
                </Dropdown>
            )
        },
        { title: 'آزمایشگاه', dataIndex: 'str_LabPersianName', key: 'str_LabPersianName', width: 150 },
        { title: 'تعداد کاربر', dataIndex: 'int_CountUserPadvish', key: 'int_CountUserPadvish', width: 150 },
        { title: 'وضعیت', dataIndex: 'str_Status', key: 'str_Status', width: 150 },
        { title: 'تاریخ درخواست', dataIndex: 'str_RequestDate', key: 'str_RequestDate', width: 150 },
        { title: 'تایید مالی', dataIndex: 'str_FinancialApproveDate', key: 'str_FinancialApproveDate', width: 150 },
        { title: 'نصاب', dataIndex: 'str_FullName', key: 'str_FullName', width: 150 },
        { title: 'تاریخ اتمام کار', dataIndex: 'str_FinilizeDate', key: 'str_FinilizeDate', width: 150 },
    ];
    const menu = (record: any) => (
        <Menu
            items={[
                // {
                //     key: "1",
                //     label:record.bit_Deleted? "بازیابی" : "حذف",
                //     onClick: () => removeRequest(record.prk_TemperatureRequest_AutoID, record.bit_Deleted? false :true),
                //     icon: <DeleteOutlined />,
                //     disabled: !(myStore.auth.loginType === 'parsicuser') || !permission ,
                //     danger: true
                // },
                {
                    key: "2",
                    label: "تایید مالی",
                    onClick: () => padvishRequestFinancialApproveClick(record.prk_PadvishInstallRequest_AutoID),
                    icon: <DollarOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.int_Status == 1) || !permission

                },
                {
                    key: "3",
                    label: "تعیین نصاب",
                    onClick: () => AssignInstaller(record.prk_PadvishInstallRequest_AutoID),
                    icon: <BuildOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.str_FullName === null && record.int_Status === 2) || !permission,
                },
                myStore.auth.loginType === 'parsicuser' ? {
                    key: "4",
                    label: "ثبت لایسنس",
                    onClick: () => licenseRegistrationClick(record.prk_PadvishInstallRequest_AutoID),
                    icon: <DeliveredProcedureOutlined />,
                    disabled: !(myStore.auth.loginType === 'parsicuser' && record.str_FullName !== null && record.int_Status >= 2) || !permission,
                } : {
                    key: "4",
                    label: "مشاهده لایسنس",
                    onClick: () => licenseRegistrationClick(record.prk_PadvishInstallRequest_AutoID),
                    icon: <DeliveredProcedureOutlined />,
                    disabled: false,
                },

            ]}
        />
    )

    const loadPadvishRequest = () => {
        if (myStore.auth.loginType === "parsicuser") {
            getPadvishRequestList()
                .then((result: any) => {
                    dispatch(UpdatePadvishRequestList({ padvishRequestList: result.data.data }))
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                    errorNotify(error.response.data.errorMessage, undefined, 5000)
                })
        }
        else {
            getLabPadvishRequestList(myStore.auth.userId ? myStore.auth.userId : 0)
                .then((result: any) => {
                    dispatch(UpdatePadvishRequestList({ padvishRequestList: result.data.data }))
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                    errorNotify(error.response.data.errorMessage, undefined, 5000)
                })
        }


    }

    const addNewOnClick = () => {
        navigate("/" + myStore.auth.loginType + "/NewPadvishRequest")
    }

    const padvishRequestFinancialApproveClick = (requestId: number) => {
        setIsLoading(true);
        padvishRequestFinancialApprove(requestId)
            .then((result: any) => {
                sucessNotify("وضعیت دماسنج به حالت در حال نصب تغییر یافت.");
                loadPadvishRequest();

                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);

                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }
    const AssignInstaller = (id: number) => {

        setShowAssignInstallerDialog(true)
        setAssignInstallerDialogPayload((values: any) => ({
            ...values,
            requestid: id,
        }));

    }
    const licenseRegistrationClick = (requestId: Number) => {
        if (myStore.auth.loginType === 'parsicuser') {
            navigate('/parsicuser/padvishLicenseRegistration', { state: { requestId } });
        }
        else {
            navigate('/labuser/LabLicense', { state: { requestId } });
        }
    }

    useEffect(() => {
        loadPadvishRequest();

        if (myStore.auth.loginType === 'parsicuser') {
            myStore.auth.permission.map((item: any) => {
                if (item.pageName == 'padvishRequest')
                    setPermission(item.isDetailAccess);
            });
        }
        else {
            setPermission(true);
        }
    }, [])
    return (
        <>
            <Row>
                <CustomTable
                    columns={columns}
                    expandedRowRender={expandedRowRender}
                    data={myStore.padvishRequestList.list}
                    isloading={isLoading}
                    onAddClick={addNewOnClick}
                    addButtonTitle={"درخواست جدید"}
                    permission={permission} />
            </Row>

            {showAssignInstallerDialog && (
                <AssignInstallerDialog
                    visible={showAssignInstallerDialog}
                    onSubmit={() => console.log(true)}
                    onCancel={() => { setShowAssignInstallerDialog(false); loadPadvishRequest(); }}
                    payLoad={assignInstallerDialogPayload}
                    setShowDialog={(value) => setShowAssignInstallerDialog(value)}
                />
            )}
        </>
    )
}

export default PadvishRequest;